module.exports = "<ui-select multiple ng-model=\"$ctrl.value\" uis-open-close=\"$ctrl.updateValue(isOpen)\">\n  <ui-select-match placeholder=\"Categories\" allow-clear=\"true\">\n    {{ $item.name }}\n  </ui-select-match>\n  <ui-select-choices repeat=\"category in $ctrl.categories | filter: $select.search track by category.id\">\n    <span ng-bind=\"category.displayname\"></span>\n  </ui-select-choices>\n</ui-select>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/event/views/categories.select.html
// module id = 626
// module chunks = 0